import { db } from '../lib/firebase';
import { collection, doc, getDoc, setDoc, updateDoc, query, where, getDocs, deleteDoc, addDoc } from 'firebase/firestore';
import { Organization } from '../types/organization';

export const organizationService = {
  async getOrganization(id: string) {
    const orgRef = doc(db, 'organizations', id);
    const orgSnap = await getDoc(orgRef);
    
    if (orgSnap.exists()) {
      return orgSnap.data() as Organization;
    }
    return null;
  },

  async updateOrganization(id: string, data: Partial<Organization>): Promise<void> {
    const docRef = doc(db, 'organizations', id);
    await updateDoc(docRef, {
      ...data,
      updatedAt: new Date()
    });
  },

  async getUserOrganizations(userId: string) {
    const orgsQuery = query(
      collection(db, 'organizations'),
      where('ownerId', '==', userId)
    );
    
    const orgsSnap = await getDocs(orgsQuery);
    return orgsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }) as Organization);
  },

  async createOrganization(data: Omit<Organization, 'id'>): Promise<Organization | null> {
    try {
      const docRef = await addDoc(collection(db, 'organizations'), {
        ...data,
        createdAt: new Date(),
        updatedAt: new Date()
      });
      
      // Visszaadjuk az új szervezetet az ID-val együtt
      return {
        id: docRef.id,
        ...data
      };
    } catch (error) {
      console.error('Error creating organization:', error);
      return null;
    }
  },

  async getAllOrganizations() {
    const orgsSnapshot = await getDocs(collection(db, 'organizations'));
    return orgsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }) as Organization);
  },

  async deleteOrganization(id: string) {
    const orgRef = doc(db, 'organizations', id);
    await deleteDoc(orgRef);
  }
}; 